// src/data/featurePagesData.js

import crmProfileVid from '../assets/features-crm-profile.mp4';
import timelineUI from '../assets/features-history-timeline.png';
import searchDemoVid from '../assets/search-demo.mp4';
import invoiceBuilderUIVid from '../assets/features-invoice-builder-ui.mp4';
import seamlessStripeIntegrationVid from '../assets/features-seamless-stripe-integration.mp4';
import invoiceListUI from '../assets/features-invoice-list.png';
import employeeFilesVid from '../assets/features-employee-files.mp4';
import timeOffTracking from '../assets/features-time-off-tracking.png';
import timesheets from '../assets/features-timesheets.png';
import calendar from '../assets/features-calendar.png';
import resources from '../assets/features-resources.png';
import jobStatusTracking from '../assets/features-job-status-tracking.png';
import employeeDocumentStorage from '../assets/features-employee-document-storage.png';
import employeeWagesVid from '../assets/features-employee-wages-vid.mp4';
import emergencyContact from '../assets/features-emergency-contact.png';
import trackAbsences from '../assets/features-track-absences.png';
import absencesCalendar from '../assets/features-absences-calendar.png';
import availabilitySafeguardVid from '../assets/features-availability-safeguard.mp4';
import payrollDashboard from '../assets/features-payroll-dashboard.png';
import timeOffSafetyNet from '../assets/features-time-off-safety-net.png';
import exportPayrollExcel from '../assets/features-export-payroll-excel.png';
import emailListSegmentation from '../assets/features-email-list-segmentation-vid.mp4';
import easyEmailBuilder from '../assets/features-easy-email-builder.png';
import emailAnalytics from '../assets/features-email-analytics.png';
import customerPortal from '../assets/features-customer-portal.png';
import securePayment from '../assets/features-secure-payment.png';
import quoteApprovalsVid from '../assets/features-quote-approvals-video.mp4';
import reportsVid from '../assets/features-reports-video.mp4';
import salesAndProfitabilityReportVid from '../assets/features-sales-and-profitability-reports-video.mp4';
import employeeReportsVid from '../assets/features-employee-reports-video.mp4';
import leadsBoardvid from '../assets/features-leads-board-video.mp4';
import automatedFollowUpsVid from '../assets/features-automated-followup-video.mp4';
import websiteForm from '../assets/features-website-form.png';
import calendarSyncVid from '../assets/features-calendar-sync-video.mp4';
import emailIntegration from '../assets/features-email-integration.png';
import googleAndMSEmail from '../assets/features-google-and-ms-email.png';
import quoteBuilder from '../assets/features-quote-builder-video.mp4';
import quoteApprovalVid from '../assets/features-quote-approval-video.mp4';
import oneClickJobConversion from '../assets/features-one-click-job-conversion.mp4';
import overdueReminderSettings from '../assets/features-overdue-reminder-settings.png';
import customizeEmailReminder from '../assets/features-customize-email-reminder.png';
import portalOverdueInvoices from '../assets/features-portal-overdue-invoices.png';
import expenses from '../assets/features-expenses.png';
import expensesReporting from '../assets/features-expenses-reporting.png';
import quickbooksExpenses from '../assets/features-quickbook-expenses.png';
import invoiceToQBvid from '../assets/features-invoice-to-QB-video.mp4';
import invoicePaymentOptions from '../assets/features-invoice-payment-options.png';
import quickbooksSetupVid from '../assets/features-quickbooks-setup-video.mp4';
import jobsKanbanBoard from '../assets/features-job-kanban-board.png';
import jobNotes from '../assets/features-job-notes.png';
import invoiceFinalCheckVid from '../assets/features-invoice-final-check-video.mp4';
import oneClickRoute from '../assets/features-one-click-route.png';
import navigateGoogleMaps from '../assets/features-navigate-google-maps.png';
import dragAndDropVid from '../assets/features-drag-and-drop-video.mp4';
import routeHealthScore from '../assets/features-route-health-score.png';

export const featurePagesData = {

  // --- 1. CRM & LEAD MANAGEMENT ---

  "client-database": {
    title: "Client Database & Interaction History",
    category: "CRM & Lead Management",
    heroHeadline: "Every customer. Every detail. One place.",
    heroSubhead: "Your entire customer history — calls, quotes, jobs, invoices — searchable in seconds from your truck or your desk.",
    steps: [
      {
        title: "1. One centralized profile",
        description: "Ditch the sticky notes and scattered spreadsheets. Every customer gets a dedicated profile containing their contact info, multiple property addresses, and active tags.",
        video: crmProfileVid
      },
      {
        title: "2. Complete interaction history",
        description: "See a chronological timeline of every quote sent, invoice paid, and email delivered. Anyone on your team can pick up right where you left off.",
        image: timelineUI
      },
      {
        // wave1-fix 0c9a3e57: global search is a mobile-app capability; web search boxes are per-page filters only
        title: "3. Instant global search on mobile",
        description: "Out in the field? The Spatchy mobile app searches across every customer by name, phone number, or email and returns results in milliseconds — right from the job site.",
        video: searchDemoVid
      }
    ],
    differenceHeadline: "Unlimited contacts. Zero per-contact fees.",
    differenceText: "Traditional CRMs punish you for growing by charging based on how many contacts you have. At Spatchy, whether you have 100 customers or 10,000, you pay the same flat rate."
  },

  "lead-tracking": {
    title: "Lead Tracking Pipeline",
    category: "CRM & Lead Management",
    heroHeadline: "No lead left behind.",
    heroSubhead: "From the first phone call to the signed job, track every prospect through your pipeline and let Spatchy remind you when to follow up.",
    steps: [
      {
        title: "1. Visual lead board",
        description: "See all your current leads in one place. Quickly convert them to a customer with the click of a button, putting them into your pipeline so you can set follow-up schedules. Leads can be edited and reassigned to different team members as needed.",
        video: leadsBoardvid
      },
      {
        title: "2. Automated follow-up schedule",
        description: "Choose from three levels of follow-up intensity: light, moderate, or aggressive. Spatchy automatically places reminders in your calendar so no lead gets dropped. Missed follow-ups show up in reporting so you can keep your team accountable.",
        video: automatedFollowUpsVid
      },
      {
        title: "3. Website form",
        description: "Spatchy's built-in website form feeds new inquiries directly into your lead pipeline and flags you the moment a new lead arrives. No more losing website visitors to an inbox nobody checks.",
        image: websiteForm
      }
    ],
    differenceHeadline: "Manage leads, not spreadsheets.",
    differenceText: "Most lead tracking tools are too complex for the field. Spatchy is fast, visual, and simple enough to update while you're walking back to your truck."
  },

  "google-microsoft-sync": {
    // wave1-rev 1a2b3c4d: reverts a5e4c093 — Google OAuth verification not approved, so Google is coming soon, not live
    title: "Microsoft 365 Sync",
    category: "CRM & Lead Management",
    heroHeadline: "Your email and calendar, in one place.",
    // wave1-noog 9a8b7c6d: Google Workspace verification has no timeline — remove all mention, Microsoft 365 only
    heroSubhead: "Connect Microsoft 365 and run your business without switching apps. Jobs, emails, and appointments — all in sync.",
    steps: [
      {
        // wave1-fix c7061e15: calendar push is one-way (outbound only); the description already scopes it correctly
        title: "1. Calendar sync",
        description: "Book a job in Spatchy and see it on your phone's native calendar instantly. Your Spatchy jobs push to your personal calendar — but your personal events stay private. Always know what the day looks like without opening multiple apps.",
        video: calendarSyncVid
      },
      {
        title: "2. Integrated email",
        description: "Send and receive client emails directly through Spatchy using your existing business email address. No more switching apps to find a thread. Actions in Spatchy sync back to your email account so nothing falls through the cracks.",
        image: emailIntegration
      },
      {
        // wave1-noog 8a7b6c5d: removed trailing Google Workspace sentence — no timeline, no claim
        title: "3. Microsoft 365 supported",
        description: "Connect your Microsoft 365 account — Outlook and Calendar — in under a minute from Settings.",
        image: googleAndMSEmail
      }
    ],
    differenceHeadline: "The center of your digital universe.",
    // wave1-noog 7a6b5c4d: removed Google Workspace roadmap sentence — no timeline, no claim
    differenceText: "We don't want to replace your favourite tools — we want to make them better. Our Microsoft 365 integration keeps your data unified and your team in sync."
  },

  // --- 2. FINANCE & INVOICING ---

  "invoicing-payments": {
    title: "Invoicing & Stripe Payments",
    category: "Finance & Invoicing",
    heroHeadline: "Invoice before you leave the driveway.",
    heroSubhead: "Turn a completed job into a professional invoice in one click. Your customer pays online. Money hits your account. Done.",
    steps: [
      {
        title: "1. One-click invoice generation",
        description: "Don't re-type what you've already quoted. Spatchy automatically converts your job details, labour hours, and materials into a professional invoice the moment you mark the job complete.",
        video: invoiceBuilderUIVid
      },
      {
        title: "2. Seamless Stripe integration",
        description: "Stop waiting for cheques in the mail. Every invoice includes a secure Pay Now button — clients pay by credit card instantly from their phone, their laptop, or the customer portal.",
        video: seamlessStripeIntegrationVid
      },
      {
        title: "3. Real-time status tracking",
        description: "Know exactly who owes you money. Spatchy tracks every invoice — Draft, Sent, Paid, Overdue — so nothing falls through the cracks and you always know where your cash flow stands.",
        image: invoiceListUI
      }
    ],
    differenceHeadline: "No Spatchy transaction fees.",
    differenceText: "We integrate directly with your Stripe account. Stripe takes their standard processing fee — Spatchy never skims anything off the top. Your flat monthly subscription is all we will ever charge."
  },

  "quote-builder": {
    title: "Quote & Estimate Builder",
    category: "Finance & Invoicing",
    heroHeadline: "Win the job before you leave the site.",
    heroSubhead: "Build a professional quote in minutes, email it on the spot, and let your customer approve it from their phone.",
    steps: [
      {
        title: "1. Rapid itemized quotes",
        description: "Pull from your saved list of services and materials to build accurate quotes on the fly. Don't see the item you need? Add it once and it saves to your list for every future quote. No more guessing on the back of a business card.",
        video: quoteBuilder
      },
      {
        title: "2. Digital approvals",
        description: "Once the quote is sent, your client accesses it in their personal portal. They can ask for changes or approve the job with one click. Approvals instantly update the quote status in Spatchy so you always know what's ready to move forward.",
        video: quoteApprovalVid
      },
      {
        title: "3. One-click job conversion",
        description: "Once a quote is approved, convert it into an active job and a draft invoice with a single click. Zero re-typing required. The whole flow from quote to invoice is handled inside Spatchy.",
        video: oneClickJobConversion
      }
    ],
    differenceHeadline: "Look like the professional you are.",
    differenceText: "First impressions matter. A clean, digital quote with your logo and clear line items wins more jobs than a handwritten note every single time."
  },

  "overdue-reminders": {
    title: "Automated Overdue Reminders",
    category: "Finance & Invoicing",
    heroHeadline: "Get paid without the awkward follow-up.",
    heroSubhead: "Spatchy automatically reminds your customers about outstanding invoices — politely, on schedule, without you lifting a finger.",
    steps: [
      {
        title: "1. Custom reminder schedules",
        description: "Choose exactly when reminders go out — 3 days before the due date, 7 days after, or whatever works for your business. You stay in control of the timing and tone.",
        image: overdueReminderSettings
      },
      {
        title: "2. Customizable reminder email",
        description: "Write the message in your own voice — as friendly or as firm as the situation calls for. Personalization fields make every reminder feel individual, not automated.",
        image: customizeEmailReminder
      },
      {
        title: "3. Pay directly from the reminder",
        description: "Customers click the link in the reminder email and land directly on their portal where they can see every outstanding invoice and pay securely via Stripe. Remove every possible barrier between you and getting paid.",
        image: portalOverdueInvoices
      }
    ],
    differenceHeadline: "Cash flow is king.",
    differenceText: "Small businesses fail because of cash flow, not lack of work. Automated reminders mean you spend your time doing the work — not chasing the money."
  },

  "quickbooks-sync": {
    title: "QuickBooks Online Sync",
    category: "Finance & Invoicing",
    heroHeadline: "Your books, always up to date.",
    heroSubhead: "Every invoice, payment, and expense in Spatchy syncs to QuickBooks automatically. Your accountant gets accurate data. You get your evenings back.",
    steps: [
      {
        title: "1. Seamless data flow",
        description: "Invoices created in Spatchy are pushed to QuickBooks with one click. No more double-entry or end-of-month reconciliation marathons. Your sales data is always current.",
        video: invoiceToQBvid
      },
      {
        title: "2. Payment matching",
        description: "Every payment syncs to QuickBooks regardless of how it was collected — cash, cheque, manual card entry, or online through the customer portal. Every method is accounted for automatically.",
        image: invoicePaymentOptions
      },
      {
        title: "3. Easy setup",
        description: "Connect your QuickBooks account in minutes. Select your default Service Account, Materials account, and Tax Code. Individual invoices and expenses can always override the default — Spatchy gives you the flexibility your accountant needs.",
        video: quickbooksSetupVid
      }
    ],
    differenceHeadline: "Enterprise power, small business simplicity.",
    differenceText: "We take the complexity out of accounting integrations. Connect once and let the data flow securely in the background — no accounting degree required."
  },

  "expense-tracking": {
    title: "Expense & Receipt Tracking",
    category: "Finance & Invoicing",
    heroHeadline: "Know your real profit on every job.",
    heroSubhead: "Log materials and costs the moment you spend them. See exactly which jobs are making you money — and which ones aren't.",
    steps: [
      {
        title: "1. Log expenses from the field",
        description: "Bought materials at the supply house? Log the expense immediately from your phone before you even leave the parking lot. Never lose a receipt in your truck again.",
        image: expenses
      },
      {
        title: "2. Tie costs to specific jobs",
        description: "Assign every expense to the job it belongs to. See which jobs are running high margins and which are costing you money. Real profitability data — not guesswork.",
        image: expensesReporting
      },
      {
        title: "3. QuickBooks sync",
        description: "Once your QuickBooks sync is set up, push expenses from Spatchy to your books with one click. Your accountant always has an accurate picture of what you are spending and where.",
        image: quickbooksExpenses
      }
    ],
    differenceHeadline: "Built for accrual and reality.",
    differenceText: "We don't just track what comes in — we track what goes out. Spatchy gives you a true picture of your actual job profitability by factoring in your real costs."
  },

  // --- 3. SMART SCHEDULING & OPERATIONS ---

  "smart-routing": {
    title: "Smart Routing & Territory Planning",
    category: "Smart Scheduling & Operations",
    heroHeadline: "More jobs. Same hours. Less driving.",
    heroSubhead: "Schedule your days so jobs are close together. Stop driving across town wasting gas and time — and start fitting one more job into every single day.",
    steps: [
      {
        title: "1. One-click route optimization",
        description: "Whether you're planning a single day or a full week, Spatchy analyzes every job on your calendar and groups them by geography. Recurring jobs and one-offs already booked are pulled in automatically — nothing gets missed. Hit optimize and your run sheet is reordered so your crew drives the shortest possible route.",
        image: oneClickRoute 
    },
      {
        title: "2. Navigate straight from the app",
        description: "When your crew is ready to roll, tap Navigate. Spatchy loads Google Maps with every job pre-loaded as waypoints in the right order. No retyping addresses. No figuring out the route on the fly. Just drive.",
        image: navigateGoogleMaps
    },
      {
        title: "3. Drag, drop, and re-optimize",
        description: "Running multiple crews? Once your routes are optimized, drag jobs between crew members on the grid. Re-optimize with one tap to make sure every crew is still running efficiently — not backtracking across town.",
        video: dragAndDropVid
    },
      {
        title: "4. Route Health score",
        description: "Spatchy scores every route and flags days where your crew is doubling back or covering too wide a geographic area. Fix the problem before the day starts — not after you have burned an extra hour and a tank of gas.",
        image: routeHealthScore
    }
    ],
    differenceHeadline: "One extra job per day. Every day.",
    differenceText: "If your crew fits one additional job into each day because they are not wasting time driving, that is thousands in additional revenue per truck per year — for zero additional labour cost. No other scheduling tool in this price range does geographic route optimization. This is enterprise-level logistics, built for small business."
  },

  "calendar-dispatching": {
    title: "Calendar & Dispatching",
    category: "Smart Scheduling & Operations",
    heroHeadline: "See your whole crew. Manage every job.",
    heroSubhead: "A drag-and-drop calendar built for trades businesses with teams. Schedule, reassign, and dispatch without a single phone call.",
    steps: [
      {
        title: "1. Drag-and-drop scheduling",
        // wave1-fix 7c6a5b4e: dropped absolute "without double-booking your team" — team double-booking prevention is unverified
        description: "Schedule new jobs or reassign them in seconds. The visual calendar lets you spot open gaps and move jobs around with a clear view of your whole crew.",
        image: calendar
      },
      {
        title: "2. Resource tracking",
        // wave1-fix 5f4e3d2c: guard is a client-side UI warning for vehicles/equipment only — no server enforcement, so soften "prevents"
        description: "Track vehicles and specialized equipment alongside your crew. Assign resources to jobs so you always know what is where. Spatchy flags a conflict if you try to assign a vehicle or piece of equipment that's already booked, so you catch it before dispatch.",
        image: resources
      },
      {
        title: "3. Live status tracking",
        description: "Watch your calendar update in real time as jobs move from Scheduled to In Progress to Completed. Stop calling your crew to find out if the job is done.",
        image: jobStatusTracking
      }
    ],
    differenceHeadline: "Syncs with the tools you already use.",
    // wave1-noog 6a5b4c3e: removed "Google Calendar sync coming soon" — no timeline, no claim
    differenceText: "Your Spatchy calendar syncs with Microsoft Outlook and Calendar. Your business schedule and your personal appointments stay in sync — and in their own lanes."
  },

  "job-tracking": {
    title: "Job Tracking & Progress",
    category: "Smart Scheduling & Operations",
    heroHeadline: "Know where every job stands. Right now.",
    heroSubhead: "From scheduled to paid, track your team's progress in real time. Stop calling your crew to ask if the job is done.",
    steps: [
      {
        title: "1. Real-time status updates",
        description: "Your job Kanban board shows every job — pending, scheduled, in progress, and completed. Filter by day, week, month, or custom date range for an instant snapshot of your work in progress.",
        image: jobsKanbanBoard
      },
      {
        title: "2. Job notes and follow-up",
        description: "Crew members can add notes to any job, flag it for follow-up, and assign it to a specific team member. Spatchy keeps the reminder alive until it is resolved — no opportunity or issue gets forgotten.",
        image: jobNotes
      },
      {
        title: "3. Post-job summary",
        description: "Before converting a job to an invoice, Spatchy prompts a final review. Last-minute additions, missed items, or customer service notes can be captured before the invoice goes out — keeping your billing clean and accurate.",
        video: invoiceFinalCheckVid
      }
    ],
    differenceHeadline: "Eliminate the 'is it done?' phone call.",
    differenceText: "Spatchy gives you the visibility to run a high-performance team without being tethered to your phone all day."
  },

  // --- 4. TEAM & HR ---

  "team-management": {
    title: "Team & HR Management",
    category: "Team & HR",
    heroHeadline: "Run your crew like a real company.",
    heroSubhead: "Digital employee files, time-off tracking, timesheets, and payroll prep — everything you need to manage a team without the paperwork.",
    steps: [
      {
        title: "1. Digital employee files",
        description: "Store driver's licences, certifications, and tax forms directly in each employee profile. Access them securely from anywhere — no more digging through filing cabinets.",
        video: employeeFilesVid
      },
      {
        // wave1-fix f0a1b2c3: no worker-facing request flow and no approval step — an owner/manager logs time off against the employee
        title: "2. Time-off tracking",
        description: "Log vacation, sick, and personal days against any employee and see them on the team calendar — all in one place. No more wall calendars or missed days off.",
        image: timeOffTracking
      },
      {
        title: "3. Simplified timesheets",
        description: "Employees clock in from their phone and assign time to specific jobs. Review and approve in one clean dashboard before payroll runs.",
        image: timesheets
      }
    ],
    differenceHeadline: "Unlimited team members.",
    differenceText: "We don't charge per seat. Add your whole crew — field techs, office staff, managers — without worrying about your monthly bill going up."
  },

  "employee-files": {
    title: "Full Digital Employee Files",
    category: "Team & HR",
    heroHeadline: "Your team's headquarters.",
    heroSubhead: "Manage certifications, contact info, and employment history in one secure, digital filing cabinet.",
    steps: [
      {
        title: "1. Secure document storage",
        description: "Store driver's licences, certifications, and tax forms directly in each employee profile. Access them whenever you need — from the office or the job site.",
        image: employeeDocumentStorage
      },
      {
        title: "2. Wage and payroll information",
        description: "Every employee's pay plan is a few clicks away. Set up clock in and out requirements to make sure all hours are properly logged before payroll runs.",
        video: employeeWagesVid
      },
      {
        title: "3. Emergency contact access",
        description: "Keep vital emergency contact information for every team member in one accessible place. Safety and organization go hand in hand.",
        image: emergencyContact
      }
    ],
    differenceHeadline: "A professional foundation.",
    differenceText: "Growing a team requires better systems. Spatchy gives you the infrastructure to transition from a crew to a company."
  },

  "time-off-tracking": {
    title: "Time-Off Tracking",
    category: "Team & HR",
    heroHeadline: "Vacation, sick, and personal time — managed.",
    // wave1-fix 8b9c0d1e: no self-service request/approval workflow — absences are logged and auto-approved
    heroSubhead: "Stop tracking time off on a wall calendar. Log and manage every absence in one central place.",
    steps: [
      {
        title: "1. Track all absences",
        description: "See every past and upcoming absence across your team at a glance — vacation, sick, and personal days all in one view. No more guessing who was off and when.",
        image: trackAbsences
      },
      {
        title: "2. Calendar integration",
        // wave1-fix 2e3f4a5b: no approval step — absences are logged, so drop "Approved"/"the moment it is approved"
        description: "Logged absences immediately appear on every team member's calendar. No more excuses for not knowing someone was off — the whole team sees it the moment it is entered.",
        image: absencesCalendar
      },
      {
        // wave1-fix 5a7c9d3b: block applies to manual job-editor assignment only, and there is no approval step
        title: "3. Time-off-aware scheduling",
        description: "Try to assign an employee to a job in the job editor during their logged time off and Spatchy blocks it. No more scheduling someone you forgot was away.",
        video: availabilitySafeguardVid
      }
    ],
    differenceHeadline: "Transparency for the whole team.",
    differenceText: "Clear time-off policies and consistent tracking reduce friction and keep your team happy. Spatchy makes the process fair and visible for everyone."
  },

  "payroll-ready": {
    title: "Payroll Ready",
    category: "Team & HR",
    heroHeadline: "Payroll done in minutes, not hours.",
    heroSubhead: "See your full payroll obligation at a glance. Approve hours, flag absences, and export to your payroll provider in one clean file.",
    steps: [
      {
        title: "1. Your payroll dashboard",
        description: "See the period's total payroll cost at a glance — broken down by employee. Hourly and salary calculations happen automatically. No spreadsheets, no manual math.",
        image: payrollDashboard
      },
      {
        title: "2. Time-off safety net",
        description: "Spatchy flags all absences before payroll runs so you can verify what qualifies for pay before submitting. Keep an eye on what your managers are approving — and stop cashflow leaks before they happen.",
        image: timeOffSafetyNet
      },
      {
        title: "3. Export to your payroll provider",
        description: "Once approved, export payroll to a CSV file ready to upload to your provider. Hours, wages, time off, and deductions — all captured in one clean file. Quick, accurate, and tied directly into your Spatchy workflow.",
        image: exportPayrollExcel
      }
    ],
    differenceHeadline: "Checks and balances.",
    differenceText: "Your payroll is your biggest cash obligation. Spatchy makes sure you are only paying what you are supposed to — because every dollar matters."
  },

  // --- 5. MARKETING & GROWTH ---

  "email-campaigns": {
    title: "Custom Segmented Email Marketing",
    category: "Marketing & Growth",
    heroHeadline: "Turn quiet months into booked-out months.",
    heroSubhead: "Send targeted emails to the right customers at the right time. Re-engage past clients, fill slow weeks, and drive repeat revenue — from inside Spatchy.",
    steps: [
      {
        title: "1. Powerful audience segmentation",
        description: "Stop blasting everyone with the same message. Filter your customer list by tags, past services, last service date, or outstanding balances to send emails that actually land.",
        video: emailListSegmentation
      },
      {
        title: "2. Easy email builder",
        description: "Write your message, add your logo, and drop in a clear call to action. No coding required. Your emails look professional without a marketing team behind them.",
        image: easyEmailBuilder
      },
      {
        title: "3. Campaign analytics",
        description: "See exactly who opened your email and who clicked your links. Track the real return on your marketing efforts — from the same dashboard where your business runs.",
        image: emailAnalytics
      }
    ],
    differenceHeadline: "Built-in growth tools.",
    differenceText: "Stop paying for a separate Mailchimp account that doesn't connect to your customer data. Spatchy handles your marketing exactly where your data already lives."
  },

  "client-portal": {
    title: "The Client Portal",
    category: "Marketing & Growth",
    heroHeadline: "Your customers help themselves. You save hours.",
    heroSubhead: "Give every client a secure login to view jobs, approve quotes, and pay invoices — without calling your office.",
    steps: [
      {
        title: "1. Personal client dashboard",
        description: "Every customer gets their own secure space to see upcoming jobs and review their full history with your company. No login headaches — they access it with just their email.",
        image: customerPortal
      },
      {
        title: "2. Self-serve payments",
        description: "Clients log in, see what they owe, and pay outstanding invoices directly. They can also download receipts for their own records — without calling your office.",
        image: securePayment
      },
      {
        title: "3. Quote approvals",
        description: "New estimates appear in the portal for review. Clients can ask questions, request changes, or approve the job with a single click. The status updates in Spatchy the moment they act.",
        video: quoteApprovalsVid
      }
    ],
    differenceHeadline: "Operate like a major brand.",
    differenceText: "A client portal is usually reserved for large corporations. Spatchy brings that same professional, self-serve experience to your small business — on every plan."
  },

  // --- 6. REPORTING & ANALYTICS ---

  "reporting-analytics": {
    title: "Financial & Operational Reports",
    category: "Reporting & Analytics",
    heroHeadline: "Stop guessing. Start growing.",
    heroSubhead: "Real-time sales, profitability, and team performance data — all in one dashboard. Know exactly how your business is doing before you close your laptop.",
    steps: [
      {
        title: "1. Full reporting suite",
        description: "See real-time data across your entire business — sales, profit, expenses, and employee productivity. Filter by any date range to track performance from daily to annual. You will never be in the dark about how your business is performing.",
        video: reportsVid
      },
      {
        title: "2. Sales and profitability",
        description: "Review your sales by day, week, month, or year — then compare against expenses to see your real profitability. Know your numbers without digging through bank statements or waiting for your accountant.",
        video: salesAndProfitabilityReportVid
      },
      {
        title: "3. Productivity tracking",
        description: "See efficiency and profitability by employee and by job. Identify who is performing and which jobs are costing more than they should. Spatchy makes accountability easy, visible, and fair.",
        video: employeeReportsVid
      }
    ],
    differenceHeadline: "No more guesswork.",
    differenceText: "We believe in facts over feelings. Our reporting suite gives you the clarity to make confident decisions and scale your business without flying blind."
  }
};